<mat-accordion>
  <mat-expansion-panel *ngIf="contactInfo.addresses && contactInfo.addresses.length > 0">
    <mat-expansion-panel-header> Addresses </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <mat-accordion>
        <mat-expansion-panel
          (opened)="addressOpened(addressSkeleton)"
          *ngFor="let addressSkeleton of contactInfo.addresses"
        >
          <mat-expansion-panel-header>
            {{ addressSkeleton.streetAddress1 }} {{ addressSkeleton.streetAddress2 }}
            <ng-container *ngIf="addressSkeleton.isDeleted">(Deleted)</ng-container>
          </mat-expansion-panel-header>
          <sd-portal-person-profile-address-audit-list
            #addressAuditList
            [addressId]="addressSkeleton.addressId"
            [loading]="addressAuditsLoading"
            [addressAudits]="addressAudits"
            (loadAddressAudits)="loadAddressAudits.emit($event)"
            (nextPage)="nextAddressAuditPage.emit($event)"
          >
          </sd-portal-person-profile-address-audit-list>
        </mat-expansion-panel>
        <ng-container *ngIf="!contactInfo.addresses || contactInfo.addresses.length < 1">
          There is no address audit information available.
        </ng-container>
      </mat-accordion>
    </ng-template>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="contactInfo.phoneNumbers && contactInfo.phoneNumbers.length > 0">
    <mat-expansion-panel-header> Phone Numbers </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <mat-accordion>
        <mat-expansion-panel
          (opened)="phoneNumberOpened(phoneNumberSkeleton)"
          *ngFor="let phoneNumberSkeleton of contactInfo.phoneNumbers"
        >
          <mat-expansion-panel-header>
            {{ phoneNumberSkeleton.phoneNumber }}
            <ng-container *ngIf="phoneNumberSkeleton.isDeleted">(Deleted)</ng-container>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <sd-portal-person-profile-phone-number-audit-list
              #phoneNumberAuditList
              [phoneNumberId]="phoneNumberSkeleton.phoneNumberId"
              [loading]="phoneNumberAuditsLoading"
              [phoneNumberAudits]="phoneNumberAudits"
              (loadPhoneNumberAudits)="loadPhoneNumberAudits.emit($event)"
              (nextPage)="nextPhoneNumberAuditsPage.emit($event)"
            >
            </sd-portal-person-profile-phone-number-audit-list>
          </ng-template>
        </mat-expansion-panel>
        <ng-container *ngIf="!contactInfo.phoneNumbers || contactInfo.phoneNumbers.length < 1">
          There is no phone number audit information available.
        </ng-container>
      </mat-accordion>
    </ng-template>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="contactInfo.emailAddresses && contactInfo.emailAddresses.length > 0">
    <mat-expansion-panel-header> Email Addresses </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <mat-accordion>
        <mat-expansion-panel
          (opened)="emailAddressOpened(emailAddressSkeleton)"
          *ngFor="let emailAddressSkeleton of contactInfo.emailAddresses"
        >
          <mat-expansion-panel-header>
            {{ emailAddressSkeleton.emailAddress }}
            <ng-container *ngIf="emailAddressSkeleton.isDeleted">(Deleted)</ng-container>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <sd-portal-person-profile-email-address-audit-list
              #emailAddressAuditList
              [emailAddressId]="emailAddressSkeleton.emailAddressId"
              [loading]="emailAddressAuditsLoading"
              [emailAddressAudits]="emailAddressAudits"
              (loadEmailAddressAudits)="loadEmailAddressAudits.emit($event)"
              (nextPage)="nextEmailAddressAuditsPage.emit($event)"
            >
            </sd-portal-person-profile-email-address-audit-list>
          </ng-template>
        </mat-expansion-panel>
        <ng-container *ngIf="!contactInfo.emailAddresses || contactInfo.emailAddresses.length < 1">
          There is no email address audit information available.
        </ng-container>
      </mat-accordion>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
